document.addEventListener('DOMContentLoaded', function () {
  const embeds = document.querySelectorAll('.rk24-blog-product');
  if (!embeds.length) return;

  const rootUrl =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  const currencyCode =
    window.Shopify &&
    window.Shopify.currency &&
    window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'EUR';

  const moneyFormatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: currencyCode
  });

  ensureReviewsIoAssets();
  renderPlaceholders();

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          const embed = entry.target;
          obs.unobserve(embed);
          loadProductCard(embed);
        });
      },
      {
        rootMargin: '200px 0px'
      }
    );

    embeds.forEach(function (embed) {
      observer.observe(embed);
    });
  } else {
    embeds.forEach(function (embed) {
      loadProductCard(embed);
    });
  }

  function renderPlaceholders() {
    embeds.forEach(function (embed) {
      embed.innerHTML = `
        <div class="rk24-blog-product__placeholder" aria-hidden="true">
          <div class="rk24-blog-product__placeholder-image"></div>
          <div>
            <div class="rk24-blog-product__placeholder-line rk24-blog-product__placeholder-line--long"></div>
            <div class="rk24-blog-product__placeholder-line rk24-blog-product__placeholder-line--medium"></div>
            <div class="rk24-blog-product__placeholder-line rk24-blog-product__placeholder-line--short"></div>
            <div class="rk24-blog-product__placeholder-button"></div>
          </div>
        </div>
      `;
    });
  }

  async function loadProductCard(embed) {
    const handle = embed.dataset.productHandle;
    if (!handle || embed.dataset.loaded === 'true') return;

    embed.classList.add('is-loading');

    try {
      const response = await fetch(`${rootUrl}products/${handle}.js`, {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Produkt nicht gefunden: ${handle}`);
      }

      const product = await response.json();

      const variant =
        product.variants && product.variants.length
          ? product.variants[0]
          : null;

      if (!variant) {
        throw new Error('Keine Variante gefunden.');
      }

      const productUrl = `${rootUrl}products/${product.handle}`;
      const imageSrc =
        product.featured_image ||
        (product.images && product.images[0]) ||
        '';

      const reviewSku = buildReviewSku(product, variant);

      // Eindeutige Klasse je Box, damit REVIEWS.io nicht alles am ersten Widget rendert
      const uniqueSnippetClass = `ruk_rating_snippet_blog_${Math.random().toString(36).slice(2, 10)}`;

      embed.innerHTML = `
        <article class="rk24-blog-product-card">
          <a
            class="rk24-blog-product-card__image"
            href="${productUrl}"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            ${
              imageSrc
                ? `<img src="${escapeHtml(imageSrc)}" alt="${escapeHtml(product.title)}" loading="lazy">`
                : ''
            }
          </a>

          <div class="rk24-blog-product-card__content">
            <h3 class="rk24-blog-product-card__title">
              <a
                href="${productUrl}"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                ${escapeHtml(product.title)}
              </a>
            </h3>

            <div class="rk24-blog-product-card__reviews">
              <div class="ruk_rating_snippet ${uniqueSnippetClass}" data-sku="${escapeHtml(reviewSku)}"></div>
            </div>

            <div class="rk24-blog-product-card__price">
              ${moneyFormatter.format((variant.price || 0) / 100)}
            </div>

            <a
              href="${productUrl}"
              class="rk24-blog-product-card__button"
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              Zum Produkt
            </a>
          </div>
        </article>
      `;

      embed.dataset.loaded = 'true';

      // Snippet für genau diese eine Box initialisieren
      initSingleReviewsSnippet(uniqueSnippetClass);
    } catch (error) {
      console.error('[rk24-blog-product]', error);
      embed.innerHTML = `
        <div class="rk24-blog-product__error">
          Produkt konnte nicht geladen werden.
        </div>
      `;
    } finally {
      embed.classList.remove('is-loading');
    }
  }

  function buildReviewSku(product, variant) {
    const parts = [];

    if (variant && variant.sku && String(variant.sku).trim() !== '') {
      parts.push(String(variant.sku).trim());
    }

    if (Array.isArray(product.variants)) {
      product.variants.forEach(function (item) {
        if (item && item.id) {
          parts.push(String(item.id));
        }
      });
    }

    if (product.handle) {
      parts.push(String(product.handle));
    }

    return [...new Set(parts)].join(';');
  }

  function ensureReviewsIoAssets() {
    if (!document.querySelector('link[data-rk24-reviewsio-css]')) {
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://widget.reviews.io/rating-snippet/dist.css';
      css.setAttribute('data-rk24-reviewsio-css', 'true');
      document.head.appendChild(css);
    }

    if (!document.querySelector('script[data-rk24-reviewsio-js]')) {
      const script = document.createElement('script');
      script.src = 'https://widget.reviews.io/rating-snippet/dist.js';
      script.async = true;
      script.setAttribute('data-rk24-reviewsio-js', 'true');
      document.head.appendChild(script);
    }
  }

  function initSingleReviewsSnippet(snippetClass) {
    waitForReviewsIo(function () {
      const selector = `.${snippetClass}`;
      const el = document.querySelector(selector);
      if (!el) return;

      el.removeAttribute('data-done');
      el.removeAttribute('data-retrieved');
      el.removeAttribute('title');
      el.removeAttribute('aria-label');
      el.innerHTML = '';

      window.ratingSnippet(snippetClass, {
        store: 'www.rasenkante24.de',
        mode: 'default',
        color: '#0E1311',
        linebreak: false,
        text: 'Reviews',
        singularText: 'Review',
        lang: 'de',
        usePolaris: true,
        showEmptyStars: false,
        showNumericalAverageRating: false
      });
    });
  }

  function waitForReviewsIo(callback, attempt) {
    const tries = attempt || 0;

    if (typeof window.ratingSnippet === 'function') {
      callback();
      return;
    }

    if (tries > 40) return;

    setTimeout(function () {
      waitForReviewsIo(callback, tries + 1);
    }, 150);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
});